import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VListItem,{attrs:{"link":"","disabled":!_vm.detail.enabled,"to":_vm.detail.to}},[_c(VListItemContent,[_c(VListItemTitle,{staticClass:"pl-2"},[_vm._v(_vm._s(_vm.detail.title))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }